import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { BusinessHoursDay, UpdateBusinessHoursRequest } from '../types/businessHours';

export const businessHoursApi = {
	/**
	 * Get the opening hours for each day of the week at a location.
	 * Returns the platform default week until the provider saves their own.
	 */
	get: async (locationId: number): Promise<BusinessHoursDay[]> =>
		apiClient.get<BusinessHoursDay[]>(API_ENDPOINTS.BUSINESS_HOURS(locationId)),

	/**
	 * Replace the opening hours of a location. These hours drive the time slots
	 * offered on the public booking and walk-in pages.
	 */
	update: async (locationId: number, days: BusinessHoursDay[]): Promise<BusinessHoursDay[]> =>
		apiClient.put<BusinessHoursDay[]>(API_ENDPOINTS.BUSINESS_HOURS(locationId), {
			days,
		} satisfies UpdateBusinessHoursRequest),
};

export default businessHoursApi;
